import React, { useState } from 'react';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { CustomExpander } from '../../../../components/CustomExpander/CustomExpander';

interface SalaryHistorySideBarProps {
  startDate: Date | null;
  endDate: Date | null;
  onDateRangeChange: (startDate: Date | null, endDate: Date | null) => void;
}

export const SalaryHistorySideBar: React.FC<SalaryHistorySideBarProps> = ({
  startDate,
  endDate,
  onDateRangeChange,
}) => {
  const [localStartDate, setLocalStartDate] = useState<Date | null>(startDate);
  const [localEndDate, setLocalEndDate] = useState<Date | null>(endDate);

  const handleSearch = () => {
    onDateRangeChange(localStartDate, localEndDate);
  };

  const styles = {
    container: {
      height: 'calc(100vh - 185px)',
      width: '250px',
      maxWidth: '250px',
      minWidth: '250px',
      maxHeight: '100vh',
      background: 'white',
      borderRadius: '8px',
      padding: '16px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      flexDirection: 'column' as const,
    },
    header: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      marginBottom: '16px',
      color: '#333',
    },
    content: {
      flex: 1,
      overflowY: 'auto' as const,
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
      paddingRight: '4px',
    },
    dateRangeContainer: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
      padding: '8px',
    },
    calendarWrapper: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
    },
    calendarLabel: {
      fontSize: '0.9rem',
      color: '#666',
    },
    buttonContainer: {
      marginTop: '16px',
      padding: '8px',
      borderTop: '1px solid #e9ecef',
    },
    searchButton: {
      width: '100%',
      backgroundColor: '#2196F3',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '12px',
      fontSize: '1rem',
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>היסטוריית משכורות</div>
      <div style={styles.content}>
        <CustomExpander>
          <div>טווח תאריכים</div>
          <div style={styles.dateRangeContainer}>
            <div style={styles.calendarWrapper}>
              <span style={styles.calendarLabel}>תאריך התחלה:</span>
              <Calendar
                value={localStartDate}
                onChange={(e) => setLocalStartDate(e.value as Date)}
                dateFormat="dd/mm/yy"
                showIcon
                iconPos="right"
                style={{
                  height: '36px',
                  width: '100%',
                  direction: 'ltr',
                }}
                inputStyle={{ direction: 'rtl' }}
              />
            </div>
            <div style={styles.calendarWrapper}>
              <span style={styles.calendarLabel}>תאריך סיום:</span>
              <Calendar
                value={localEndDate}
                onChange={(e) => setLocalEndDate(e.value as Date)}
                dateFormat="dd/mm/yy"
                showIcon
                iconPos="right"
                style={{
                  height: '36px',
                  width: '100%',
                  direction: 'ltr',
                }}
                inputStyle={{ direction: 'rtl' }}
                minDate={localStartDate || undefined}
              />
            </div>
          </div>
        </CustomExpander>
      </div>

      <div style={styles.buttonContainer}>
        <Button
          label="חפש"
          icon="pi pi-search"
          style={styles.searchButton}
          onClick={handleSearch}
        />
      </div>
    </div>
  );
};
